<template>
<div class="chapter">
<div class="inner_page">
<p class="imagefp"><img alt="Cover: The Quilter's Apprentice, by Jennifer Chiaverini" class="imagefp" src="images/9781439142578.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?136cb112